import React from 'react'
import { formatDateTime, priceFormatLocal } from 'utils/helper'

import { useStyles } from './style'
import { Box, Button, Checkbox } from '@mui/material'

const OrderListItemMobile = ({ data, showDetail, ...props }) => {
  const styles = useStyles()
  const userData = JSON.parse(localStorage.getItem('userdata'))

  const canSelect = data.order.status === 'WAITING APPROVAL HOD' && userData?.role === 'hod'

  return (
    <div className={styles.boxItem} style={{ borderRadius: 8 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 2,
          pl: canSelect ? 0.5 : 2,
          py: canSelect ? 0 : 1
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {canSelect && (
            <>
              <Checkbox
                className={styles.checkboxCustom}
                style={{ padding: 0 }}
                checked={props.selectedOrder.includes(data.order.id)}
                onChange={() => props.setSelectedOrder(data.order.id)}
              />
            </>
          )}
          {/* <p
            className={styles.headerText}
            style={{ color: '#ff3a59', cursor: 'pointer' }}
            onClick={() => showDetail(data)}
          >
            {data.order.order_number}
          </p> */}
        </div>
        {/* <p style={{ justifySelf: 'end', fontSize: 13 }}>{formatDateTime(data.order.created_at)}</p> */}
      </Box>
      <Box sx={{ px: 2, pb: 2 }}>
        <table className={styles.orderTable}>
          <tr>
            <td>PO Number</td>
            <td>:</td>
            <td>
              <p
                className={styles.headerText}
                style={{ color: '#ff3a59', cursor: 'pointer' }}
                onClick={() => showDetail(data)}
              >
                {data.order.order_number}
              </p>
            </td>
          </tr>
          <tr>
            <td>Date</td>
            <td>:</td>
            <td>{formatDateTime(data.order.created_at)}</td>
          </tr>
          <tr>
            <td>Requestor</td>
            <td>:</td>
            <td>{data.order.customer.name}</td>
          </tr>
          <tr>
            <td>Department</td>
            <td>:</td>
            <td>
              {data.departments && data.departments.length > 0
                ? data.departments[0].department.name
                : '-'}
            </td>
          </tr>
          <tr>
            <td>Cost Center</td>
            <td>:</td>
            <td>
              {data.cost_centers && data.cost_centers.length > 0
                ? data.cost_centers[0].cost_center.name
                : '-'}
            </td>
          </tr>
          <tr>
            <td>PO Status</td>
            <td>:</td>
            <td>{data.order.status}</td>
          </tr>
        </table>
      </Box>
      <Box
        className='d-flex justify-content-between rounded grey-box'
        sx={{ px: 2, py: 1, backgroundColor: '#F0F4F7' }}
      >
        <p style={{ fontWeight: 'bold' }}>Amount</p>
        <p style={{ fontWeight: 'bold' }}>{priceFormatLocal(data.order.grand_total)}</p>
      </Box>
      <Box sx={{ mt: 1, pb: 2, px: 2 }}>
        <Button
          fullWidth
          variant='contained'
          sx={{ bgcolor: '#ff3a59' }}
          onClick={() => showDetail(data)}
        >
          Detail Order
        </Button>
      </Box>
    </div>
  )
}

export default OrderListItemMobile
